
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {amountUtils} from "../../assets/js/utils";

export default {
directives: {
TransferDom
},
components: {
Group,
Cell,
XTable,CellBox,XButton, XDialog
},
created(){
this.getInfo();
},
mounted () {
},
methods: {
getInfo(){
let shopId = this.shopId;
let uri = this.apiBaseUri+"GET_SHOP_BILL_DETAIL";
let params = {
"shopId":this.shopId,
"billNo":this.billNo,
};
let _this = this;
_this.axios.post(uri, params, {
headers: {}
}).then(function (response) {
let data = response.data;
if (data.code == 0 && data.data) {
_this.detailInfo = data.data;
} else {
_this.showHideOnBlur = true;
_this.dialogMsg = response.data.msg;
}
}).catch(function (response) {
_this.showHideOnBlur = true;
_this.dialogMsg = response.message;
});
},
doConfirm (){
if(this.isBtnLoading) {return;}
this.isBtnLoading = true;
let _this = this;
_this.axios.post(this.apiBaseUri+"SHOP_BILL_CONFIRM", {
shopId:this.shopId,
billNo: this.billNo
}, {
headers: {}
}).then(function (response) {
let data = response.data;
if (data.code != undefined && data.code == 0) {
_this.detailInfo.status = 2;
_this.showHideOnBlur = true;
_this.dialogMsg = "操作成功";
} else {
_this.showHideOnBlur = false;
_this.dialogMsg = data.msg;
}
_this.isBtnLoading = false;
}).catch(function (response) {
_this.showHideOnBlur = true;
_this.dialogMsg = response.message;
_this.isBtnLoading = false;
});

},
buttonDisabled(){
return (Number.isNaN(Number(this.detailInfo.status)))||this.detailInfo.status==2||this.detailInfo.status==3||this.detailInfo.status==4;
},
transform: amountUtils.transform
},
data () {
let shopId = this.$route.params.shopId;
return {
detailInfo: new Proxy({}, {get:(target, name)=>{
if(typeof target[name] == "undefined"){
return "加载中...";
}
}}),
dialogMsg: '',
showHideOnBlur:false,
isBtnLoading:false,
shopId,
billNo: this.$route.params.billNo,
apiBaseUri: '/v1/shop/'+ shopId+'/bill/'
}
}
}



// WEBPACK FOOTER //
// ./src/components/financial/Detail.vue